"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assert = _interopRequireDefault(require("assert"));

var _service = _interopRequireDefault(require("./service"));

/**
 * A class wrapper around features.
 */
var Features =
/*#__PURE__*/
function () {
  function Features() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var apps = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2["default"])(this, Features);
    this.flags = options.flags || {};
    this._default = options["default"] === true;
    this._debug = options.debug === true;
    this._apps = apps || {};
    this._organization = this._apps.organization;
    (0, _assert["default"])(this._organization, 'ERROR: Unable to determine organization.');
    this._name = this._apps.name;
    (0, _assert["default"])(this._name, 'ERROR: Unable to determine environment name.');

    if (this._debug) {
      this.log("Organization = ".concat(this._organization));
      this.log("Name = ".concat(this._name));
    }

    this.reset();
  }

  (0, _createClass2["default"])(Features, [{
    key: "generateFlags",
    value: function generateFlags(feature, flags) {
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var defaultFlag = arguments.length > 3 ? arguments[3] : undefined;
      (0, _assert["default"])(Array.isArray(flags), "Expected flags to be an array: ".concat(flags));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = flags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var flag = _step.value;
          var tokens = flag.split(':');
          this.log("EnabledTokens: ".concat(tokens));

          if (tokens.length !== 2) {
            console.error("ERROR: Invalid feature configuration specified: ".concat(flag, ", ignoring."));
            continue;
          }

          var _tokens = (0, _slicedToArray2["default"])(tokens, 2),
              organization = _tokens[0],
              name = _tokens[1];

          if ((organization === '*' || this._organization === organization) && (name === '*' || this._name === name)) {
            this.log("Found a matching config: ".concat(flag, " for feature: ").concat(feature)); // Feature flag matches the organization and environment name.

            if (this._data.has(feature)) {
              // Feature is already enabled.
              if (enabled) {
                // The feature is already enabled.
                console.warn("WARN: Feature \"".concat(feature, "\" is already enabled; found additional flag: \"").concat(flag, "\""));
              } else {
                // The feature flag is conflicting.
                console.warn("WARN: Feature \"".concat(feature, "\" is already enabled; found conflicting flag: \"").concat(flag, "\"")); // Overwrite the flag with the last known value.

                this._data["delete"](feature);
              }
            } else if (enabled) {
              // Feature is not enabled yet.
              this._data.add(feature);
            } // Break out of the loop once a match is found


            this.log("Matching config for \"".concat(feature, "\" overrides any default values for that feature"));
            break;
          } else {
            this.log("Config: ".concat(flag, " is not a match for feature: ").concat(feature));

            if (defaultFlag) {
              // The value wasn't found and the default flag is true, enabled the feature.
              this.log("Enabling feature: ".concat(feature, " based on the default value of: ").concat(defaultFlag));

              this._data.add(feature);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(feature) {
      return this._data.has(feature);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(feature) {
      return !this.isEnabled(feature);
    }
  }, {
    key: "enable",
    value: function enable(feature) {
      if (!this._data.has(feature)) {
        this._data.add(feature);
      }
    }
  }, {
    key: "disable",
    value: function disable(feature) {
      this._data["delete"](feature);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._data = new Set();

      for (var feature in this.flags) {
        this.log("Processing feature: ".concat(feature));
        var featureFlag = this.flags[feature];
        var enabledFlags = featureFlag.enabled;

        if (enabledFlags && !Array.isArray(enabledFlags)) {
          enabledFlags = [enabledFlags];
        }

        if (enabledFlags) {
          this.generateFlags(feature, enabledFlags, true, featureFlag["default"] === true);
        }

        var disabledFlags = featureFlag.disabled;

        if (disabledFlags && !Array.isArray(disabledFlags)) {
          disabledFlags = [disabledFlags];
        }

        if (disabledFlags) {
          this.generateFlags(feature, disabledFlags, false, featureFlag["default"] === true);
        }

        if (!enabledFlags && !disabledFlags) {
          // Error: enabled or disabled should exist.
          throw new Error("Invalid flag configuration for feature: ".concat(feature, "; enabled or disabled should be specified."));
        }
      }

      if (this._debug) {
        this.log(JSON.stringify(Array.from(this._data)));
      }
    }
  }, {
    key: "log",
    value: function log(s) {
      if (this._debug) {
        console.log("Features::".concat(s));
      }
    }
  }, {
    key: "apps",
    get: function get() {
      return this._apps;
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }]);
  return Features;
}();

var instance = function instance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _service["default"].fetchApps().then(function (apps) {
    try {
      var f = new Features(options, apps);
      return Promise.resolve(f);
    } catch (err) {
      return Promise.reject(err);
    }
  });
};

var _default = {
  instance: instance
};
exports["default"] = _default;
//# sourceMappingURL=index.js.map